import request from '@/utils/request'

/**
 * 查询小区列表（admin 下拉使用，数据来自物业中台）
 * @returns {Promise} Promise对象
 */
export function queryAdminCommunityList() {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.queryAdminCommunity',
      method: 'get',
      params: { page: 1, row: 1000 }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
